import React from "react";
import SoftBox from "StyleFeatures/SoftBox";
import SoftTypography from "StyleFeatures/SoftTypography";
import CoverLayout from "Common/CoverLayout";
import curved9 from "assets/images/curved-images/curved-6.jpg";
import { useNavigate } from "react-router-dom";
import SoftButton from "StyleFeatures/SoftButton";
function CandidateForgotCheckEmail() {
  const navigate = useNavigate();

  return (
    <CoverLayout
      title="Check Your Email"
      description="We’ve sent you an email to set your password"
      image={curved9}
    >
      <SoftBox textAlign="center">

        {/* Heading */}
        <SoftTypography variant="h6" fontWeight="bold" mb={2}>
          Reset Link Sent 🎉
        </SoftTypography>

        {/* Main Message */}
        <SoftTypography variant="body2" color="text" mb={3}>
          We’ve sent a password reset link to your email.
        </SoftTypography>

        <SoftTypography variant="body2" color="text" mb={3}>
          Please check your email to <b>reset your password</b>.
        </SoftTypography>

        {/* Extra Info */}
        <SoftTypography variant="body2" color="text" mb={4}>
          The link will expire in <b>1 hour</b>.  
          Don’t forget to check your spam folder if you don’t see the email.
        </SoftTypography>

      </SoftBox>
    </CoverLayout>
  );
}

export default CandidateForgotCheckEmail;
